import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const AbstractTenant = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24.733 13.229"
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
      fill={fill}
    >
      <path d="M0 13.229l7.19-9.49h5.177l-7.19 9.491zm12.079-3.738L19.556 0h5.177l-7.478 9.491z" />
    </svg>
  );
};

AbstractTenant.displayName = 'AbstractTenant';
